import React, { useState, useEffect } from "react";
import {
    Space, Row, Col, Breadcrumb,
    Typography,
    Divider,
    Card,
    Button,
    Tag,
} from "antd";
import { Link, useParams } from "react-router-dom";
import {
    HomeOutlined,
} from "@ant-design/icons";
import { Helmet } from "react-helmet-async";
import { Freelancers } from "../Offer/FreelancersPage";
const { Title } = Typography;

const MarketplaceFreelancersPage = () => {
    const { tagFromUrl } = useParams(); // Fetch tag from URL
    return (
        <>
            <Helmet>
                <title>{tagFromUrl ? tagFromUrl : "Freelancerzy na Taskizy.com"}</title>
            </Helmet>
            <div style={{ background: "#f8f9fa", minHeight: "100vh" }}>
                {/* Hero Section */}
                <section style={{ 
                    padding: "80px 20px", 
                    textAlign: "center", 
                    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)", 
                    color: "white" 
                }}>
                    <div style={{ maxWidth: "800px", margin: "0 auto" }}>
                        <div style={{ fontSize: "clamp(60px, 12vw, 120px)", lineHeight: "1", marginBottom: "24px" }}>
                            👥
                        </div>
                        <Title level={1} style={{ 
                            color: "white", 
                            fontSize: "clamp(2rem, 5vw, 3.5rem)", 
                            marginBottom: "24px" 
                        }}>
                            Znajdź wykonawcę {tagFromUrl ? `zadania "${tagFromUrl}"` : "dla swojego zadania"}
                        </Title>
                        <Typography.Paragraph style={{ 
                            fontSize: "clamp(1rem, 2.5vw, 1.25rem)", 
                            color: "rgba(255,255,255,0.9)", 
                            marginBottom: "40px" 
                        }}>
                            Znajdź doświadczonych wykonawców gotowych do realizacji Twoich zadań. 
                            Bezpieczne płatności kartami podarunkowymi.
                        </Typography.Paragraph>
                        <Link to="/transactions">
                            <Button type="primary" size="large" style={{ 
                                height: "56px", 
                                fontSize: "18px", 
                                fontWeight: "600",
                                padding: "0 40px" 
                            }}>
                                Zleć zadanie
                            </Button>
                        </Link>
                    </div>
                </section>

                {/* Popular Skills Section */}
                <section style={{ padding: "60px 20px", background: "#fff" }}>
                    <div style={{ maxWidth: "1200px", margin: "0 auto", textAlign: "center" }}>
                        <Title level={3} style={{ marginBottom: "30px", color: "#2c3e50" }}>
                            Popularne umiejętności
                        </Title>
                        <div style={{ 
                            display: "flex", 
                            justifyContent: "center", 
                            flexWrap: "wrap", 
                            gap: "12px",
                            marginBottom: "40px"
                        }}>
                            {[
                                "PHP", "UX", "WordPress", "ReactJS", "JavaScript", "AWS", "Android"
                            ].map(skill => (
                                <Link key={skill} to={`/marketplace/freelancers/${skill}`}>
                                    <Tag 
                                        style={{ 
                                            padding: "8px 16px", 
                                            fontSize: "14px",
                                            borderRadius: "20px",
                                            border: "1px solid #667eea",
                                            color: "#667eea",
                                            background: "rgba(102, 126, 234, 0.1)",
                                            cursor: "pointer",
                                            transition: "all 0.3s ease"
                                        }}
                                        onMouseEnter={(e) => {
                                            e.target.style.background = "#667eea";
                                            e.target.style.color = "white";
                                        }}
                                        onMouseLeave={(e) => {
                                            e.target.style.background = "rgba(102, 126, 234, 0.1)";
                                            e.target.style.color = "#667eea";
                                        }}
                                    >
                                        #{skill}
                                    </Tag>
                                </Link>
                            ))}
                        </div>
                    </div>
                </section>

                {/* CTA for Freelancers */}
                <section style={{ padding: "40px 20px", background: "#667eea" }}>
                    <div style={{ maxWidth: "1200px", margin: "0 auto", textAlign: "center" }}>
                        <Card style={{ 
                            border: "none", 
                            boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
                            borderRadius: "12px"
                        }}>
                            <div style={{ padding: "20px" }}>
                                <Title level={4} style={{ marginBottom: "16px", color: "#2c3e50" }}>
                                    🚀 Jesteś wykonawcą?
                                </Title>
                                <Typography.Paragraph style={{ marginBottom: "20px", color: "#6c757d" }}>
                                    Dołącz do Taskizy i zarabiaj karty podarunkowe za realizację zadań!
                                </Typography.Paragraph>
                                <Link to="/account/register">
                                    <Button type="primary" size="large" style={{
                                        height: "56px",
                                        fontSize: "18px",
                                        fontWeight: "600"
                                    }}>
                                        Dołącz do Taskizy
                                    </Button>
                                </Link>
                            </div>
                        </Card>
                    </div>
                </section>

                {/* Freelancers List */}
                <section style={{ padding: "60px 20px" }}>
                    <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
                        <Freelancers tagFromUrl={tagFromUrl} limit={100} paginationLimit={100} />
                    </div>
                </section>
            </div>
        </>
    );
};

export default MarketplaceFreelancersPage;
